import { InboxMenuItem } from "./inbox-models";

export const DividerMenu: InboxMenuItem = {
  menuItemType: "DIVIDER",
};
